import { Node } from "@xyflow/react";
import { NodeAttributionSourceType, OutgoingBackendNode } from "../types";

export function attributeNodesByType(
  nodes: Node[],
  attributionSourceType: NodeAttributionSourceType,
) {
  return nodes.map((node) => ({
    ...node,
    data: {
      ...node.data,
      attributionSourceType,
    },
  }));
}

export function attributeBackendNodesByType(
  nodes: OutgoingBackendNode[],
  attributionSourceType: NodeAttributionSourceType,
) {
  return nodes.map((node) => ({
    ...node,
    attribution_source_type: attributionSourceType,
  }));
}
